module.exports = __webpack_public_path__ + "static/img/qq_2.4cc147f4.png";